export const TagErrorCode = {
    UNSUPPORTED_BROWSER: '100',
    DEPENDENCY_LOAD_FAILURE: '110',
    IMA_LOAD_FAILURE: '111',
    IMA_LOAD_FAILURE_FF_PRIVATE_MODE: '112',
    AD_BLOCKER_CBS_ANON_USER: '113',
    AD_BLOCKER_CBS_LC_USER: '114',
    METADATA_LOAD_ERROR_PAGE: '120',
    METADATA_LOAD_ERROR_CAN: '121',
    METADATA_SERVICE_NOT_ALLOWED: '122',
    NO_ENCODE_FOUND: '123',
    MPX_CALL_FAILURE: '124',
    MPX_DATA_INVALID: '125',
    RCO_UNDEFINED: '200'
};
